import React from 'react';

const WaveText = ({ text, className = "" }) => {
  return (
    <span className={`wave-text ${className}`}>
      {text.split('').map((char, i) => (
        <span key={i}>{char === ' ' ? '\u00A0' : char}</span>
      ))}
    </span>
  );
};

export default WaveText;
